type SsoCallbackAttribution = {
  inviteId?: string;
  promo?: string;
  referrer?: string;
};

export const buildSsoCallbackUrl = (
  origin: string,
  attribution: SsoCallbackAttribution,
  path: string = 'sso-callback',
): string => {
  const normalizedPath = path.replace(/^\/+/, '');
  const definedEntries = Object.entries(attribution).filter((entry): entry is [string, string] => Boolean(entry[1]));
  const search = new URLSearchParams(definedEntries).toString();
  return `${new URL(normalizedPath, `${origin}/`).toString()}${search ? `?${search}` : ''}`;
};
